import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, ChevronDown } from "lucide-react";
import api from "@/lib/api";

const REQUIREMENTS = ["Permanent Recruitment", "Contract Staffing", "Recruitment Process Outsourcing (RPO)", "Payroll Management", "Multiple Solutions", "General Enquiry"];

const inputCls =
  "w-full h-12 rounded-xl border border-slate-200 bg-white px-4 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition-all duration-300 hover:border-slate-300 focus:border-brand-red focus:ring-2 focus:ring-brand-red/15";

export default function EmployerForm({ defaultRequirement = "Permanent Recruitment", submitLabel = "Share Your Hiring Requirement", testId = "employer-enquiry-form" }) {
  const [form, setForm] = useState({
    name: "", company: "", work_email: "", phone: "",
    hiring_requirement: defaultRequirement, positions: "", message: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", { ...form, positions: form.positions ? Number(form.positions) : null });
      toast.success("Thank you — your requirement has been received. Our team will reach out shortly.");
      setForm({ name: "", company: "", work_email: "", phone: "", hiring_requirement: defaultRequirement, positions: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={testId} className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <input required placeholder="Name" value={form.name} onChange={set("name")} className={inputCls} data-testid="enquiry-name-input" />
      <input placeholder="Company" value={form.company} onChange={set("company")} className={inputCls} data-testid="enquiry-company-input" />
      <input required type="email" placeholder="Work Email" value={form.work_email} onChange={set("work_email")} className={inputCls} data-testid="enquiry-email-input" />
      <input placeholder="Phone" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="enquiry-phone-input" />
      <div className="relative">
        <select value={form.hiring_requirement} onChange={set("hiring_requirement")} className={`${inputCls} appearance-none pr-10 cursor-pointer`} data-testid="enquiry-requirement-select">
          {REQUIREMENTS.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
        <ChevronDown size={15} className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-slate-400" />
      </div>
      <input type="number" min="1" placeholder="Number of Positions" value={form.positions} onChange={set("positions")}
        className={`${inputCls} [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none`} data-testid="enquiry-positions-input" />
      <textarea placeholder="Message" rows={5} value={form.message} onChange={set("message")}
        className="w-full min-h-[128px] rounded-xl border border-slate-200 bg-white px-4 py-3.5 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition-all duration-300 hover:border-slate-300 focus:border-brand-red focus:ring-2 focus:ring-brand-red/15 sm:col-span-2 resize-none"
        data-testid="enquiry-message-input" />
      <button type="submit" disabled={loading} data-testid="enquiry-submit-button"
        className="sm:col-span-2 group inline-flex h-[52px] items-center justify-center gap-2 bg-brand-red hover:bg-brand-dark text-white font-medium text-sm px-8 rounded-xl transition-all duration-300 hover:shadow-[0_16px_40px_-12px_rgba(181,51,49,0.6)] disabled:opacity-60">
        {loading ? "Sending..." : submitLabel}
        <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </form>
  );
}
